import { connect } from 'react-redux';
import { BasePage } from '../../pages/base';
import { selectSearchBarProps } from '../../redux/selectors/location';
import { DiscoverState } from '../../types';

const _mapStateToProps = (state: DiscoverState, ownProps: any) => {
    const { searchBarProps, ...restProps } = ownProps;

    return {
        ...restProps,
        searchBar: {
            ...selectSearchBarProps(state),
            ...searchBarProps,
        },
    };
};

export default connect(_mapStateToProps)(BasePage);
